// @flow
import * as React from 'react';
import usePersonnel from 'common/hooks/usePersonnel';

const isGlobalPersonnelRule = uischema => {
    return (
        uischema.rule?.condition &&
        Object.keys(uischema.rule.condition).includes('isGlobalPersonnel')
    );
};

const useEnabled = ({ uischema, enabled }) => {
    const personnel = usePersonnel();
    return React.useMemo(() => {
        if (!enabled) {
            return false;
        }
        if (isGlobalPersonnelRule(uischema)) {
            const isDisabled =
                personnel.isGlobalPersonnel() ===
                uischema.rule.condition.isGlobalPersonnel;
            return !isDisabled;
        }
        return true;
    }, [uischema, enabled, personnel]);
};

export default useEnabled;
